/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-inner-declarations */
import { firstBy } from 'thenby';
import { Channel } from '../Channel';
import { SortOrder, SortType } from '../Sort';
import { PivotSortOrder } from './PivotQuery';
export class PivotSortType {
    constructor() {
        this._baseSorts = new Map();
        this._layerSorts = new Map();
    }
    get baseSorts() {
        return this._baseSorts;
    }
    get layerSorts() {
        return this._layerSorts;
    }
    getBaseSort(sortName) {
        return this.baseSorts.get(sortName);
    }
    getLayerSort(layerName, sortName) {
        const layerSorts = this.layerSorts.get(layerName);
        if (layerSorts !== undefined) {
            return layerSorts.get(sortName);
        }
    }
    addBaseSort(sortName, sort) {
        if (!this.baseSorts.has(sortName)) {
            this.baseSorts.set(sortName, sort);
        }
        return this;
    }
    addLayerSort(layerName, sortName, sort) {
        let layerSorts = this.layerSorts.get(layerName);
        if (layerSorts == null) {
            layerSorts = new Map();
            this.layerSorts.set(layerName, layerSorts);
        }
        if (!layerSorts.has(sortName)) {
            layerSorts.set(sortName, sort);
        }
        return this;
    }
}
export var PivotSort;
(function (PivotSort) {
    function makePivotSort(model, query) {
        const pivotSort = new PivotSortType();
        switch (query.sortOrder) {
            case PivotSortOrder.ANY:
                return addSortByAny(pivotSort, model, query);
            case PivotSortOrder.ROW:
                return addSortByRow(pivotSort, model, query);
            case PivotSortOrder.COLUMN:
                return addSortByColumn(pivotSort, model, query);
            default:
                return pivotSort;
        }
    }
    PivotSort.makePivotSort = makePivotSort;
    function executePivotSort(model, query, result, pivotSort) {
        // Sort Base
        const baseSort = makeSortFunc(model, query, pivotSort.baseSorts);
        if (baseSort != null) {
            result.base.data.sort(baseSort);
        }
        // Sort Layers
        for (const [layerName, layerSorts] of Array.from(pivotSort.layerSorts)) {
            const layer = result.getResultSet(layerName);
            // pass the result in here not just the data...
            const layerSort = makeSortFunc(model, query, layerSorts);
            if (layer != null && layerSort != null) {
                layer.data.sort(layerSort);
            }
        }
        return result;
    }
    PivotSort.executePivotSort = executePivotSort;
    function makeSortFunc(model, query, sorts) {
        let sortFunc = null;
        for (const [, sort] of Array.from(sorts)) {
            const sortOrder = makeSortOrder(sort);
            const compareFunc = makeCompareFunc(model, query, sort);
            if (sortFunc == null) {
                sortFunc = firstBy(compareFunc, sortOrder);
            }
            else {
                sortFunc = sortFunc.thenBy(compareFunc, sortOrder);
            }
        }
        return sortFunc;
    }
    function addSortByAny(pivotSort, model, query) {
        pivotSort = addBaseSorts(pivotSort, model, query, query.rows.dimensions);
        pivotSort = addBaseSorts(pivotSort, model, query, query.columns.dimensions);
        for (const layer of getLayers(query)) {
            pivotSort = addLayerSorts(pivotSort, model, query, query.rows.dimensions, layer.name);
            pivotSort = addLayerSorts(pivotSort, model, query, query.columns.dimensions, layer.name);
            pivotSort = addMarkSorts(pivotSort, model, query, layer);
        }
        return pivotSort;
    }
    function addSortByRow(pivotSort, model, query) {
        pivotSort = addBaseSorts(pivotSort, model, query, query.rows.dimensions);
        pivotSort = addBaseSorts(pivotSort, model, query, query.columns.dimensions);
        for (const layer of getLayers(query)) {
            pivotSort = addLayerSorts(pivotSort, model, query, query.rows.dimensions, layer.name);
            pivotSort = addLayerSorts(pivotSort, model, query, query.columns.dimensions, layer.name);
            pivotSort = addMarkSorts(pivotSort, model, query, layer);
        }
        return pivotSort;
    }
    function addSortByColumn(pivotSort, model, query) {
        pivotSort = addBaseSorts(pivotSort, model, query, query.columns.dimensions);
        pivotSort = addBaseSorts(pivotSort, model, query, query.rows.dimensions);
        for (const layer of getLayers(query)) {
            pivotSort = addLayerSorts(pivotSort, model, query, query.columns.dimensions, layer.name);
            pivotSort = addLayerSorts(pivotSort, model, query, query.rows.dimensions, layer.name);
            pivotSort = addMarkSorts(pivotSort, model, query, layer);
        }
        return pivotSort;
    }
    /**
     * Helpers
     */
    function getLayers(query) {
        if (query.layers.get(Channel.STAR).length > 0) {
            return query.layers.get(Channel.STAR);
        }
        if (query.layers.get(Channel.ROW).length > 0) {
            return query.layers.get(Channel.ROW);
        }
        if (query.layers.get(Channel.COLUMN).length > 0) {
            return query.layers.get(Channel.COLUMN);
        }
        return new Array();
    }
    /**
     * Function Creation
     */
    function addBaseSorts(pivotSort, model, query, fields) {
        for (const field of fields) {
            let sort;
            if (query.sorts.has(field.name)) {
                sort = query.sorts.get(field.name);
            }
            else {
                sort = model.buildDataSort(field, SortOrder.ASC);
            }
            pivotSort = pivotSort.addBaseSort(sort.field.name, sort);
        }
        return pivotSort;
    }
    function addLayerSorts(pivotSort, model, query, fields, layerName) {
        for (const field of fields) {
            let sort;
            if (query.sorts.has(field.name)) {
                sort = query.sorts.get(field.name);
            }
            else {
                sort = model.buildDataSort(field, SortOrder.ASC);
            }
            pivotSort = pivotSort.addLayerSort(layerName, sort.field.name, sort);
        }
        return pivotSort;
    }
    function addMarkSorts(pivotSort, model, query, layer) {
        return [
            Channel.ROW,
            Channel.COLUMN,
            Channel.VALUE,
            Channel.COLOR,
            Channel.SIZE,
            Channel.TEXT,
            Channel.DETAIL,
            Channel.TOOLTIP,
            Channel.ANGLE,
            Channel.PATH,
        ].reduce((sorts, channel) => {
            return addLayerSorts(sorts, model, query, layer.dimensions.get(channel) || [], layer.name);
        }, pivotSort);
    }
    /**
     * Sort Comparators
     */
    function makeSortOrder(sort) {
        return sort.order === 'ASC' ? 1 : -1;
    }
    function makeCompareFunc(model, query, sort) {
        switch (sort.type) {
            case SortType.DATA:
                return makeDataSortFunc(sort);
            case SortType.ALPHA:
                return makeAlphaSortFunc(model, sort);
            case SortType.FIELD:
                return makeFieldSortFunc(model, query, sort);
        }
    }
    function makeDataSortFunc(sort) {
        return (r1, r2) => {
            const val1 = r1[sort.field.alias];
            const val2 = r2[sort.field.alias];
            return val1 === val2 ? 0 : val1 > val2 ? 1 : -1;
        };
    }
    function makeAlphaSortFunc(model, sort) {
        const formula = makeAlphaSortFormula(model, sort);
        return (r1, r2) => {
            const val1 = formula.expr.value({ row: r1 });
            const val2 = formula.expr.value({ row: r2 });
            return val1 === val2 ? 0 : val1 > val2 ? 1 : -1;
        };
    }
    function makeAlphaSortFormula(model, sort) {
        let source = `[${sort.field.alias}]`;
        switch (sort.field.dataType) {
            case 'DATEQTR':
                source = `DATENAME('quarter', DATEPARSE('Q', ${source}))`;
                break;
            case 'DATEMONTH':
                source = `DATENAME('month', DATEPARSE('M', ${source}))`;
                break;
            case 'DATEWKDAY':
                source = `DATENAME('weekday', DATEPARSE('i', ${source}))`;
                break;
            default:
                source = `STR(${source})`;
        }
        return model.compile(source);
    }
    function makeFieldSortFunc(model, query, sort) {
        const values = makeSortValues(model, query, sort);
        return (r1, r2) => {
            const val1 = values.get(r1[sort.field.alias]);
            const val2 = values.get(r2[sort.field.alias]);
            return val1 === val2 ? 0 : val1 > val2 ? 1 : -1;
        };
    }
    function makeSortValues(model, query, sort) {
        const mapping = model.onPivot((pivot) => {
            pivot.onRows((rows) => {
                rows.onField(sort.field);
                for (const field of query.rows.fields) {
                    if (field.isDiscrete) {
                        rows.onField(field);
                    }
                }
                for (const field of query.columns.fields) {
                    if (field.isDiscrete) {
                        rows.onField(field);
                    }
                }
                rows.onLayer(sort.byField);
            });
            if (sort.byField.isValues) {
                pivot.onValues((pValues) => {
                    pValues.onField(...query.values.fields);
                });
            }
            pivot.filterBy(...Array.from(query.filters.values()));
        });
        const result = mapping.execute(model);
        const data = result.getResultSet(sort.byField.alias).data;
        const values = data.reduce((mapped, row) => {
            const fieldValue = row[sort.field.alias];
            const byFieldValue = row[sort.byField.alias];
            if (!mapped.has(fieldValue)) {
                return mapped.set(fieldValue, byFieldValue);
            }
            else {
                return mapped.set(fieldValue, mapped.get(fieldValue) + byFieldValue);
            }
        }, new Map());
        const dir = sort.order === SortOrder.DESC ? -1 : 1;
        const sorted = Array.from(values).sort(([, a], [, b]) => {
            return (a - b) * dir;
        });
        return new Map(sorted);
    }
})(PivotSort || (PivotSort = {}));
